import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete} from '../utils/request';
import {toastr} from 'react-redux-toastr';

export function loadRolesSuccess(roles){
  return {type: types.LOAD_ROLES_SUCCESS, roles};
}

export function loadRoles() {
  return function (dispatch) {
    dispatch(loadRolesSuccess({loaded: false, items: []}));
    return apiRequest(`/api/roles`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching roles, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadRolesSuccess({loaded: true, items: []}));
        } else {
          dispatch(loadRolesSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}
